import React, { ReactElement } from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import WithPage from '../../HOC/Page/WithPage';
import buildHelpers from '../../utils/buildHelpers';
import utils from '../../utils';
import { WinnersTabs } from '../../models/Winners';
import Widgets from '../../blades/Widgets';
import MainLayout from '../../layout/MainLayout';
import { getAllContentEntries, getPageData } from '../../models/Contentful';
import type { Page } from '../../models/Contentful/types';
import { CType, DefaultPage, IStaticPageProps } from '../../models/Contentful/types';
import { LayoutPage } from '../../types/page';

const WINNERS = 'winners';

const Page: LayoutPage<IStaticPageProps<DefaultPage>> = ({ page }) => {
  return (
    <div>
      <div>
        <main>
          <Widgets widget={page.widget as unknown as CType<unknown>[]} />
        </main>
      </div>
    </div>
  );
};

Page.getLayout = function getLayout(page: ReactElement, props: IStaticPageProps<DefaultPage>) {
  return <MainLayout {...props}>{page}</MainLayout>;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const winnerPage = await getAllContentEntries<Page>({
    content_type: 'pages',
  });

  let WinnersSlugs = WinnersTabs.map(({ slug }) => ({
    params: { slug: [slug] },
  }));

  WinnersSlugs = utils.filterUndefinedSlugs(WinnersSlugs);

  buildHelpers.writePagesMeta(
    WinnersTabs.map(tab => ({
      fields: {
        slug: `${WINNERS}/${tab.slug}`,
        directory: '',
        entryId: WINNERS,
        seoMetadata: winnerPage.items[0].fields.seoMetadata,
      },
      sys: winnerPage.items[0].sys,
    })),
  );
  return {
    paths: WinnersSlugs,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps<IStaticPageProps<DefaultPage>> = async ({ params }) => {
  const slug = params?.slug || [''];
  const pageResponse = await getPageData<DefaultPage>(WINNERS);
  const res = { ...pageResponse, key: slug[slug.length - 1] };

  return { props: res };
};

export default WithPage(Page);
